import { useCopyPasteHandlers } from './useCopyPasteHandlers';
import { useKeyboardKeyEvent } from '../WorkflowCanvas/hooks';
import { isPrimaryModifierPressed } from '../Search/helpers';
import { isTargetInputElement } from './helpers';
import { useCallback, useContext } from 'react';
import { useHandleDiffMode } from './handleDiff';
import { UserContext } from '~/dashboard/context';

type SnippetCopyPasteProps = {
  isCanvasFocused: boolean;
};

export default function SnippetCopyPaste({ isCanvasFocused }: SnippetCopyPasteProps) {
  const { handleCopy, handlePaste } = useCopyPasteHandlers();
  const { featureFlags } = useContext(UserContext);
  const handleDiffMode = useHandleDiffMode();

  const canUseKeyboardEvent = useCallback((event: KeyboardEvent) => {
    if (!isPrimaryModifierPressed(event)) {
      return false;
    }

    if (!isCanvasFocused) {
      return false;
    }

    if (isTargetInputElement(event)) {
      return false;
    }

    return true;
  }, [isCanvasFocused]);

  useKeyboardKeyEvent('c', event => {
    if (!canUseKeyboardEvent(event)) {
      return;
    }
    handleCopy();
  });

  useKeyboardKeyEvent('v', event => {
    if (!canUseKeyboardEvent(event)) {
      return;
    }
    handlePaste();
  });

  useKeyboardKeyEvent('/', event => {
    if (!canUseKeyboardEvent(event)) {
      return;
    }
    if (featureFlags?.enableWorkflowDiff) {
      handleDiffMode();
    }
  });

  return null;
}

